import { ContactsFilled, FileDoneOutlined, LoadingOutlined, SyncOutlined } from '@ant-design/icons'
import { CancelRunButton } from '@components/OrderDispatch/OptimizerWizard/components/CancelRunButton'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useMemo } from 'react'
import { useLockedOrders } from '@hooks/useLockedOrders'
import { useLockedSchedules } from '@hooks/useLockedSchedules'
import type { NewRunHeaderProps } from '../types'

export function NewRunHeader({ startOptimizerRun, loading, selectedRun, resetOptimizer }: NewRunHeaderProps) {
  const { lockedOrders } = useLockedOrders()
  const { lockedSchedules } = useLockedSchedules()

  const selectOrderCount = useMemo(
    () => lockedOrders?.filter((o) => o.run_id === selectedRun?.id)?.length,
    [lockedOrders, selectedRun]
  )
  const selectScheduleCount = useMemo(
    () => lockedSchedules?.filter((sched: Gravitate.Schedule) => sched.run_id === selectedRun?.id)?.length,
    [lockedSchedules, selectedRun]
  )

  return (
    <Horizontal
      className='p-2'
      style={{ background: 'var(--theme-color-2-dim)' }}
      justifyContent='space-between'
      verticalCenter
    >
      {/* Blurb */}
      <Vertical alignItems='start' justifyContent='center' className='py-2 ml-4' flex='0 1 auto'>
        <Texto category='h3'>New Optimization Run </Texto>
        <Texto>Select your driver schedules and orders for optimization. </Texto>
      </Vertical>

      {/* Selected */}
      <Horizontal verticalCenter>
        <Horizontal className='m-1 mr-4' verticalCenter>
          <Horizontal className='bg-1 pr-3 pl-3' verticalCenter style={{ border: '1px solid var(--theme-color-2)' }}>
            <FileDoneOutlined style={{ fontSize: '1.5em', color: 'var(--theme-color-2)' }} />
            <Texto className='pr-2 pl-2' style={{ whiteSpace: 'nowrap' }} category='h2'>
              {selectOrderCount || 0}
            </Texto>
            <Texto>Orders Selected</Texto>
          </Horizontal>
        </Horizontal>
        <Horizontal className='m-1 mr-4' verticalCenter>
          <Horizontal className='bg-1 pr-3 pl-3' verticalCenter style={{ border: '1px solid var(--theme-color-2)' }}>
            <ContactsFilled style={{ fontSize: '2em', color: 'var(--theme-color-2)' }} />
            <Texto className='pr-2 pl-2' style={{ whiteSpace: 'nowrap' }} category='h2'>
              {selectScheduleCount || 0}
            </Texto>
            <Texto>Drivers Selected</Texto>
          </Horizontal>
        </Horizontal>
      </Horizontal>

      {/* Action Buttons */}
      <Horizontal>
        <GraviButton
          disabled={selectOrderCount === 0 || selectScheduleCount === 0 || !!loading}
          className='m-1 mr-4 optimizer-run-button'
          style={{ width: '175px' }}
          theme2
          buttonText={
            <>
              {loading === 'optimizing' ? (
                <LoadingOutlined className='mr-3' />
              ) : (
                <SyncOutlined className='mr-3' rotate={90} />
              )}
              RUN OPTIMIZATION
            </>
          }
          onClick={startOptimizerRun}
        />
        <CancelRunButton
          selectedRunId={selectedRun?.id}
          createdBy={selectedRun?.created_by}
          resetOptimizer={resetOptimizer}
          width='175px'
        />
      </Horizontal>
    </Horizontal>
  )
}
